import * as $ from 'jquery';
import {UIElement} from "./ui";
import '/modules/common/css/ui/checkboxes-set.css';
import '/modules/common/css/ui/checkboxes-set.mobile.css';
import {AbstractOptionList} from "./MultiOptionList";

/**
 * A set of checkboxes
 * @extends UIElement
 */
class CheckboxesSet extends AbstractOptionList {

    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Dropdown id
     * @param values {Array<String>} A list of option values
     * @param labels {Array<String>} A list of option labels (can be an HTML element)
     * @param initialValue {Array<string>} The initial selected values
     * @param mandatory {boolean} Is it mandatory to choose a value?
     * @param onChange {function} A callback to be called when the value changes
     */
    constructor(translator, isMobileDevice, id, values, labels, initialValue, mandatory, onChange) {
        super(translator, isMobileDevice, id, values, labels, initialValue === undefined || initialValue === null ? [] : initialValue, mandatory, onChange);
    }

    getClassName() {
        return "CheckboxesSet";
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<div id="' + this.id + '" class="checkboxes-input"></div>');
            this._setOptions();
            const self = this;
            $('input', this.uiElement).on('change', function () {
                if (this.blockChangeTrigger)
                    return;
                let val = self.value;
                if ($(this).is(':checked')) {
                    val.push($(this).val());
                } else {
                    const index = val.indexOf($(this).val());
                    if (index > -1)
                        val.splice(index, 1);
                }
                self._setValue(val, true);
                self._autoDisable();
                self.logStat("SET_VALUE {" + val.join(',') + "}");
            });
        }
        return this.uiElement;
    }

    _autoDisable() {
        if (this.getValue().length >= this.getMaxSelectable()) {
            this.disableValues(this.values.filter(v => this.getValue().indexOf(v) < 0));
        } else {
            this.disableValues([]);
        }
    }

    getMaxSelectable() {
        return this.maxSelectable ? Math.min(this.maxSelectable,this.getPossibleValues().length) : this.getPossibleValues().length;
    }

    setMaxSelectable(maxSelectable) {
        this.maxSelectable = maxSelectable;
        this._autoDisable();
        return this;
    }

    _setOptions() {
        this.uiElement.empty();
        for (let i = 0; i < this.values.length; i++) {
            const val = this.values[i];
            this.uiElement.append($('<label val="' + val + '"><input ' + (this.value.indexOf(val) >= 0 ? 'checked' : '') + ' type="checkbox" name="' + this.id + '" value="' + val + '"/>' + this.labels[i] + '</label>'));
        }
        this._autoDisable();
    }

    _setValue(value, triggerOnChange) {
        this.blockChangeTrigger = true;
        this.value = value;
        $("input", this.uiElement).removeAttr('checked');
        value.forEach(v => $("input[value='" + v + "']", this.uiElement).attr('checked', 'checked'));
        this.blockChangeTrigger = false;
        if (triggerOnChange) {
            this.onChangeCallbacks.forEach(c=>c(this))
        }
    }
}

export {CheckboxesSet}